import { Box, Typography, VerifiedIcon } from '@iheartjane/reefer';
import type { MouseEvent, ReactNode } from 'react';

import {
  ApplyableDiscountItem,
  ApplyableDiscountWrapper,
} from './customerLoyaltyPoints.styles';

interface ApplyableDiscountProps {
  applied: boolean;
  children?: ReactNode;
  /** Stable hook for e2e; emotion's `styled` forwards data-* to the DOM. */
  dataTestId?: string;
  enabled: boolean;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
  text: string;
}

export const ApplyableDiscount = ({
  applied,
  dataTestId,
  enabled,
  onClick,
  text,
  children,
}: ApplyableDiscountProps) => {
  return (
    <ApplyableDiscountWrapper
      data-testid={dataTestId}
      enabled={enabled}
      onClick={onClick}
      role="button"
    >
      <Box mr={8}>
        <VerifiedIcon mt={2} color={applied ? 'success' : 'grape-light'} />
      </Box>
      <ApplyableDiscountItem>
        <Typography color="grays-black" variant="body">
          {text}
          {enabled && children}
        </Typography>
      </ApplyableDiscountItem>
    </ApplyableDiscountWrapper>
  );
};
